<main-header></main-header>

<div class="qt-login-wrapper">
  <section class="qt-login" aria-labelledby="qt-login-title">
    <h1 id="qt-login-title" class="qt-login__title">Sign in</h1>

    <form
      (ngSubmit)="loginForm.form.valid ? onSubmit() : focusFirstInvalidField(formElement)"
      #loginForm="ngForm"
      #formElement
      novalidate
    >
      <div class="qt-field" [class.--invalid]="email.invalid && (email.touched || loginForm.submitted)">
        <label class="qt-field__label" for="login-email">Username</label>
        <div class="qt-field__control">
          <i class="header-icon --user qt-field__icon"></i>
          <input
            id="login-email"
            type="text"
            class="qt-field__input"
            name="email"
            autocomplete="username"
            required
            [(ngModel)]="formData.email"
            #email="ngModel"
          />
        </div>
        <div class="qt-field__error" aria-live="polite">
          <span *ngIf="email.invalid && (email.touched || loginForm.submitted)">Username is required</span>
        </div>
      </div>

      <div class="qt-field" [class.--invalid]="password.invalid && (password.touched || loginForm.submitted)">
        <label class="qt-field__label" for="login-password">Password</label>
        <div class="qt-field__control">
          <i class="header-icon --locked qt-field__icon"></i>
          <input
            id="login-password"
            [type]="showPassword ? 'text' : 'password'"
            class="qt-field__input --with-toggle"
            name="password"
            autocomplete="current-password"
            required
            [(ngModel)]="formData.password"
            #password="ngModel"
          />
          <button
            type="button"
            class="qt-field__toggle"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            [attr.aria-pressed]="showPassword"
            (click)="showPassword = !showPassword"
          >
            <i class="header-icon" [ngClass]="showPassword ? '--eye-off' : '--eye'"></i>
          </button>
        </div>
        <div class="qt-field__error" aria-live="polite">
          <span *ngIf="password.invalid && (password.touched || loginForm.submitted)">Password is required</span>
        </div>
      </div>

      <button type="submit" class="qt-login__submit">Login</button>
    </form>
  </section>
</div>
